const COLD_SIGNUP_ORGANIZATION_KEY = "waColdSignupOrganizationId";

/** Remember the org whose cold sign up link was used, so it survives the Auth0 login round-trip. */
export const setColdSignupOrganizationId = (organizationId: string) =>
  sessionStorage.setItem(COLD_SIGNUP_ORGANIZATION_KEY, organizationId);

/** Read and clear the remembered cold sign up org. */
export const consumeColdSignupOrganizationId = () => {
  const organizationId = sessionStorage.getItem(COLD_SIGNUP_ORGANIZATION_KEY);
  sessionStorage.removeItem(COLD_SIGNUP_ORGANIZATION_KEY);
  return organizationId;
};
